import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'
import { cx } from 'class-variance-authority'
import { startsWithHttpOrHttps } from '../../Utils/functionnals'
import { getRandomPrimaryColor } from '../../constants'

interface FirmHeaderMediaProps {
  url: string | IGatsbyImageData | null
  name: string
  colorCareerSite?: string
}

const FirmHeaderMedia = ({
  url,
  name,
  colorCareerSite = undefined,
}: FirmHeaderMediaProps) => {
  const colorToDisplay = useMemo(
    () => (colorCareerSite ? undefined : getRandomPrimaryColor()),
    [colorCareerSite],
  )

  if (url && typeof url === 'string' && startsWithHttpOrHttps(url)) {
    return (
      <img
        src={url}
        alt={`header ${name}`}
        className="object-cover w-full h-32 lg:h-36"
      />
    )
  }

  if (url && typeof url === 'object') {
    const headerMediaImage = getImage(url as IGatsbyImageData)
    return (
      <div>
        <GatsbyImage
          image={headerMediaImage as IGatsbyImageData}
          alt={`header de ${name}`}
          className="object-cover w-full h-32 lg:h-36"
        />
      </div>
    )
  }

  return (
    <div
      className={cx(
        'w-full h-32 lg:h-36 bg-opacity-70',
        colorToDisplay && `bg-${colorToDisplay}`,
      )}
      style={{
        backgroundColor: colorCareerSite,
      }}
    />
  )
}

export default FirmHeaderMedia
